var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "55px",
    height: "36.684px",
    viewBox: "0 0 55 36.684",
    enableBackground: "new 0 0 55 36.684",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#00A79D",
    d: "M39.991,33.305H11.894V19.332h28.098V33.305z M13.394,31.805h25.098V20.832H13.394V31.805z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#00A79D",
    d: "M38.862,20.832h-4.978v-5.194c0-4.379-3.562-7.942-7.942-7.942c-4.379,0-7.942,3.562-7.942,7.942v5.194 h-4.978v-5.194c0-7.124,5.796-12.919,12.92-12.919s12.92,5.795,12.92,12.919V20.832z M35.385,19.332h1.978v-3.694 c0-6.296-5.123-11.419-11.42-11.419s-11.42,5.123-11.42,11.419v3.694H16.5v-3.694c0-5.206,4.236-9.442,9.442-9.442 c5.207,0,9.442,4.236,9.442,9.442V19.332z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.367a6cf24b65f87904fbe2be27313c91.svg";
export { ForwardRef as ReactComponent };